import { ready } from '../global/instantiate';
import blogFilters from './../components/blogFilters';
import viewMoreButton from '../sections/blogs/viewMoreBtn';

ready(() => {
  blogFilters();
  viewMoreButton();
});
